module.exports = __webpack_public_path__ + "img/pds.00750957.png";